<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeSuFullInventoryDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 zx-min-h-modal">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            {{ "su-management.inventory-management.show-all-branches" | translate }}
        </h4>
        <!-- loading -->
        <div *ngIf="isLoading" class="d-flex w-100 flex-grow-1 justify-content-center align-items-center">
            <mat-spinner class="zx-medium-icon-size"></mat-spinner>
        </div>
        <!-- full inventory container -->
        <div *ngIf="!isLoading" class="d-flex flex-column flex-grow-1 w-100 pb-2">
            <div *ngFor="let cl of clusters" class="d-flex flex-column w-100 pb-4">
                <!-- cluster title -->
                <span class="d-flex pb-2 text-green">
                    <b>
                        {{ "choose-branch.naming." + cl.serial_name | translate }}
                    </b>
                </span>
                <!-- plotter -->
                <article class="d-flex flex-column w-100 pb-2" *ngIf="cl.plotter?.length > 0">
                    <div *ngFor="let br of cl.plotter" class="d-flex flex-column w-100">
                        <!-- branch title -->
                        <span class="d-flex pb-2 text-green">
                            <span>
                                {{ "choose-branch.naming.plotter." + br.serial_name | translate }}
                            </span>
                        </span>
                        <!-- branch inventory -->
                        <div class="row">
                            <span *ngFor="let con of br.stockCurrent?.paper | keyvalue"
                                class="col-3 col-md-2 col-xl-1 d-flex flex-column align-items-center shadow-85 rounded-2"
                                [class.text-red]="con.value === 0">
                                <span class="d-flex gap-1 align-items-center">
                                    <img src="/assets/images/paper-roll-icon.svg" class="zx-tiny-icon-size svg">
                                    <span class="text-center zx-text-small">
                                        {{ 'paper-type.name-short.' + con.key | translate }}
                                    </span>
                                </span>
                                <b>
                                    {{ con.value }}
                                </b>
                            </span>
                            <span *ngFor="let con of br.stockCurrent?.ink | keyvalue"
                                class="col-3 col-md-2 col-xl-1 d-flex flex-column align-items-center shadow-85 rounded-2"
                                [class.text-red]="con.value === 0">
                                <span class="d-flex align-items-center">
                                    <span class="ink-icon-con">
                                        <mat-icon class="ink-icon">invert_colors</mat-icon>
                                    </span>
                                    <span class="text-center zx-text-small">
                                        {{ con.key === 'waste' ? ('ink-type.name.Waste.short' | translate) : con.key }}
                                    </span>
                                </span>
                                <b>
                                    {{ con.value }}
                                </b>
                            </span>
                        </div>
                        <!-- // branch inventory -->
                    </div>
                </article>
                <!-- express -->
                <article class="d-flex flex-column w-100 pb-2" *ngIf="cl.express?.length > 0">
                    <div *ngFor="let br of cl.express" class="d-flex flex-column w-100">
                        <!-- branch title -->
                        <span class="d-flex pb-2 text-green">
                            <span>
                                {{ "choose-branch.naming.express." + br.serial_name | translate }}
                            </span>
                        </span>
                        <!-- branch inventory -->
                        <div class="row">
                            <span *ngFor="let con of br.stockCurrent?.paper | keyvalue"
                                class="col-3 col-md-2 col-xl-1 d-flex flex-column align-items-center shadow-85 rounded-2"
                                [class.text-red]="con.value === 0">
                                <span class="d-flex gap-1 align-items-center">
                                    <img src="/assets/images/paper-roll-icon.svg" class="zx-tiny-icon-size svg">
                                    <span class="text-center zx-text-small">
                                        {{ 'paper-type.name-short.' + con.key | translate }}
                                    </span>
                                </span>
                                <b>
                                    {{ con.value }}
                                </b>
                            </span>
                            <span *ngFor="let con of br.stockCurrent?.ink | keyvalue" class=" col-3 col-md-2 col-xl-1 d-flex flex-column align-items-center shadow-85
                                rounded-2" [class.text-red]="con.value === 0">
                                <span class="d-flex align-items-center">
                                    <span class="ink-icon-con">
                                        <mat-icon class="ink-icon">invert_colors</mat-icon>
                                    </span>
                                    <span class="text-center zx-text-small">
                                        {{ con.key === 'Waste' ? ('ink-type.name.Waste.short' | translate) : con.key }}
                                    </span>
                                </span>
                                <b>
                                    {{ con.value }}
                                </b>
                            </span>
                        </div>
                        <!-- // branch inventory -->
                    </div>
                </article>
            </div>
        </div>
        <!-- // full inventory container -->

    </div>

</div>